import { GeofencesService } from '../services/geofences-service';
import { TerminalGeofencesModelBase } from './terminal-geofences-model';
import { ZoneFeature, Zones } from './zones-base-interfaces';

export class TerminalGeofencesModelImpl extends TerminalGeofencesModelBase {
    async getTerminalGeofences(): Promise<ZoneFeature[] | null> {
        await this._loadingPromise;

        return this._zones!.features;
    }

    constructor(geojson?: Zones) {
        super();

        if (geojson) {
            this._zones = geojson;
        } else {
            this._loadingPromise = this._loadGeoJson();
            setInterval(() => this._loadGeoJson(), 24*60*60*1000); // refresh terminal geofences every 24h
        }
    }

    private _zones: Zones | null = null;
    private _loadingPromise: Promise<void> | null = null;

    private async _loadGeoJson() {
        const zones: Zones = await GeofencesService.fetchGeofences();
        if (zones) {
            this._zones = zones;
        }
    }
}
